import { ActivateVendorPayload } from '@models/payload/vendor';
import { CreateAvailabilityTimePayload } from '../../models/payload/availabilityTime';
import { ropoloRequest } from '../axios';

const getAvailabilityTime = async () => (await ropoloRequest.identityVendorsAvailabilitytimeList()).data;

const createAvailabilityTimeService = async (params: CreateAvailabilityTimePayload) =>
  (await ropoloRequest.identityVendorsAvailabilitytimeCreate(params)).data;

const removeAvailabilityTimeService = async (id: string) =>
  (await ropoloRequest.identityVendorsAvailabilitytimeDelete(id)).data;

const changeVendorActivation = async (command: ActivateVendorPayload) =>
  (await ropoloRequest.identityVendorsActivateUpdate(command)).data;

const getVendorAvailabilityTime = async () => (await ropoloRequest.identityAvailabilitytimeList()).data;

export {
  changeVendorActivation,
  createAvailabilityTimeService,
  getAvailabilityTime,
  getVendorAvailabilityTime,
  removeAvailabilityTimeService,
};
